import { useMemo } from "react";
const buttonStyleMap = {
    default: {
        default: {
            type: 'default',
            className: 'default-default'
        },
        success: {
            type: 'default',
            className: 'default-default'
        },
        warning: {
            type: 'default',
            className: 'default-default'
        },
        danger: {
            type: 'default',
            className: 'default-default'
        }
    },
    primary: {
        default: {
            type: 'primary',
            className: 'primary-default'
        },
        success: {
            type: 'primary',
            className: 'primary-success'
        },
        warning: {
            type: 'primary',
            className: 'primary-warning'
        },
        danger: {
            type: 'primary',
            className: 'primary-danger'
        }
    },
    secondary: {
        default: {
            variant: 'outlined',
            color: 'primary',
            className: 'secondary-default'
        },
        success: {
            variant: 'outlined',
            color: 'primary',
            className: 'secondary-success'
        },
        warning: {
            variant: 'outlined',
            color: 'primary',
            className: 'secondary-warning'
        },
        danger: {
            variant: 'outlined',
            color: 'primary',
            className: 'secondary-danger'
        }
    },
    dashed: {
        default: {
            type: 'dashed',
            className: 'dashed-default'
        },
        success: {
            type: 'dashed',
            className: 'dashed-default'
        },
        warning: {
            type: 'dashed',
            className: 'dashed-default'
        },
        danger: {
            type: 'dashed',
            className: 'dashed-default'
        }
    },
    link: {
        default: {
            type: 'link',
            className: 'link-default'
        },
        success: {
            type: 'link',
            className: 'link-success'
        },
        warning: {
            type: 'link',
            className: 'link-warning'
        },
        danger: {
            type: 'link',
            className: 'link-danger'
        }
    },
    text: {
        default: {
            type: 'text',
            className: 'text-default'
        },
        success: {
            type: 'text',
            className: 'text-default'
        },
        warning: {
            type: 'text',
            className: 'text-default'
        },
        danger: {
            type: 'text',
            className: 'text-default'
        }
    }
};
function useButtonColor(props) {
    const { type = 'default', color = 'default' } = props;
    const buttonColorProps = useMemo(()=>buttonStyleMap[type]?.[color] || {}, [
        type,
        color
    ]);
    return {
        buttonColorProps
    };
}
export { useButtonColor as default };
